interface Card {
  meta: string;
  name: string;
  tone: 'live' | 'normal' | 'dim';
}

const cards: Card[] = [
  { meta: 'LIVE NOW · SURAT', name: 'Vibrant Gujarat Surat', tone: 'live' },
  { meta: 'JUL 18 · MUMBAI', name: 'IIJS Premiere 2026', tone: 'normal' },
  { meta: 'SEP 14 · NOIDA', name: 'MSME Trade Fair', tone: 'dim' },
];

export function DiscoveryStack() {
  return (
    <div className="flex flex-col gap-2 w-full max-w-[280px]">
      {cards.map((c, i) => (
        <div
          key={i}
          className={`bg-white rounded-md px-3.5 py-2.5 transition-all duration-base ease-mela border ${
            c.tone === 'live'
              ? 'border-saffron-500 shadow-card'
              : c.tone === 'dim'
              ? 'border-ink-200 opacity-70'
              : 'border-violet-200'
          }`}
        >
          <div
            className={`font-mono text-[10px] tracking-wide mb-1 flex items-center gap-1.5 ${
              c.tone === 'live'
                ? 'text-saffron-700'
                : c.tone === 'dim'
                ? 'text-ink-500'
                : 'text-violet-600'
            }`}
          >
            {c.tone === 'live' && (
              <span className="w-1.5 h-1.5 rounded-full bg-saffron-500 animate-live-pulse" aria-hidden="true" />
            )}
            {c.meta}
          </div>
          <div className="text-[13px] font-semibold text-ink-900">{c.name}</div>
        </div>
      ))}
    </div>
  );
}
